export type Volume = {
  number: string;
  title: string;
  tagline: string;
  intro: string[];
  listLabel: string;
  items: string[];
  flow?: string[];
  outro: string[];
};

export const volumes: Volume[] = [
  {
    number: "I",
    title: "The Master Session Blueprint",
    tagline: "Stop asking yourself, “Where do I start?”",
    intro: ["In this volume, I'll show you how the entire system works and how to use the Blueprint to organize a basic reflexology practice session."],
    listLabel: "Inside you'll find",
    items: ["How to use the system", "The complete session flow", "The different practice stages", "How to move from one stage to the next", "Preparation framework", "Reference framework", "Organization system", "Master checklist", "Visual session map"],
    outro: ["This is your starting point for understanding the entire Blueprint system."],
  },
  {
    number: "II",
    title: "The Visual Preparation & Orientation System",
    tagline: "Get organized before you begin and quickly find what you need",
    intro: ["One of the biggest challenges when practicing isn't having information. It's knowing what to look at before you begin.", "This volume organizes the preparation and orientation stage into a simple visual system."],
    listLabel: "Inside you'll find",
    items: ["Preparation checklist", "Practice space setup", "Reference materials", "Orientation guide", "How to quickly find a resource", "Visual index", "Preparation worksheets", "Quick-reference guide", "Pre-practice checklist"],
    outro: ["So you can begin with a clear structure instead of improvising."],
  },
  {
    number: "III",
    title: "The Visual Reference System™",
    tagline: "Stop wasting time searching through different charts and notes",
    intro: ["This volume becomes your quick-reference system. Key information is organized visually so you can find what you need during study and practice."],
    listLabel: "Inside you'll find",
    items: ["Visual reference pages", "Map organization", "Location guides", "Quick indexes", "Essential terminology", "Reference sheets", "Visual comparison pages", "Foot reference materials", "Hand reference materials", "Quick-reference sheets"],
    outro: ["Open it. Find what you need. Keep moving."],
  },
  {
    number: "IV",
    title: "The Step-by-Step Practice Flow™",
    tagline: "Turn scattered information into a sequence you can actually follow",
    intro: ["This is the heart of the system:"],
    flow: ["Prepare", "Orient", "Practice", "Close", "Record"],
    listLabel: "Inside you'll find",
    items: ["General practice structure", "Step-by-step sequence", "Stage transition guides", "Organization tips", "Practice checklists", "Practice tracking sheets", "Suggested timing framework", "Opening structure", "Closing structure", "Visual practice flow"],
    outro: ["You don't have to improvise the order. You have a structure you can reference while you practice."],
  },
  {
    number: "V",
    title: "The Practice Organization Library™",
    tagline: "Multiple structured practice frameworks organized in one place",
    intro: ["I created this volume for anyone who wants ready-to-reference educational wellness practice frameworks organized using the same simple structure."],
    listLabel: "Each framework includes",
    items: ["Practice objective", "Preparation", "References", "Suggested duration", "Sequence", "Application order", "Practice notes", "Closing", "Checklist"],
    outro: ["This makes it easier to organize your practice consistently, regardless of what you're reviewing."],
  },
  {
    number: "VI",
    title: "The Pocket Practice Guide™",
    tagline: "Take your practice system with you",
    intro: ["This is my compact quick-reference volume. I designed it so you can access the essential parts of the system from your phone, tablet, or computer."],
    listLabel: "Inside you'll find",
    items: ["Quick-reference pages", "Session worksheets", "Practice logs", "Pre-practice checklists", "Post-practice checklists", "Progress tracker", "Practice notes", "Personal reference pages", "Session flow", "Mini Blueprint"],
    outro: ["It's your compact version of the system whenever you don't want to open everything."],
  },
];
